import { devCenterAppActionsModalLoadedSrc96Evid183, devCenterMyAppsModalCtaClickSrc96Evid184, } from '@wix/bi-logger-app-market-data/v2';
export const buildCliModalLoadedEvent = ({ modalName, route, devUxType, appId, }) => devCenterAppActionsModalLoadedSrc96Evid183({
    modal_name: modalName,
    route,
    ...(devUxType && { dev_ux_type: devUxType }),
    ...(appId && { app_id: appId }),
});
export const buildCliModalCtaClickEvent = ({ modalName, route, ctaName, toUrl, devUxType, appId, }) => devCenterMyAppsModalCtaClickSrc96Evid184({
    modal_name: modalName,
    cta_name: ctaName,
    route,
    ...(devUxType && { dev_ux_type: devUxType }),
    ...(toUrl && { to_url: toUrl }),
    ...(appId && { app_id: appId }),
});
//# sourceMappingURL=cliModalBiEvents.js.map